/* eslint-disable max-len */
/* eslint-disable sort-keys-fix/sort-keys-fix */
export const onboardingMessages = {
    // General
    'Onboarding.comingSoon': 'Coming soon',
    'Onboarding.currentStep': 'Step {{stepNumber}} of {{totalSteps}}',
    'Onboarding.select': 'Select',
    'Onboarding.time.minute': '1 Minute',
    'Onboarding.time.minute.plural': '{{minutes}} Minutes',

    // Footer
    'Onboarding.footer.preferSalesTeam':
        'Do you prefer to have our technical sales team help you?',
    'Onboarding.footer.contactUs.salesEmail': 'sales@auvik.com',
    'Onboarding.footer.contactUs': 'Contact Us',
    'Onboarding.footer.advancedSetup': 'Exit Setup Guide',

    // ChooseStep
    'Onboarding.chooseOptionStep.title': 'Your account is all set up!',
    'Onboarding.chooseOptionStep.subtitle':
        'It’s time to start discovering your SaaS applications',
    'Onboarding.chooseOptionStep.intro':
        'Get started quickly by integrating with your identity platform, or deploy our SaaS agent and browser extension for full visibility.</br></br>Don’t worry if you change your mind in the middle of the process. You can run a quick scan or deploy the agent on the platform at any time.',
    'Onboarding.chooseOptionStep.recommended': 'Recommended',
    'Onboarding.chooseOptionStep.runQuickScan.title': 'Run Quick Scan',
    'Onboarding.chooseOptionStep.runQuickScan.intro':
        'Quick Scan allows you to sync your organization’s cloud-based identity and access management service. Provides identity and access management capabilities for limited cloud applications.',
    'Onboarding.chooseOptionStep.runQuickScan.microsoftEntraID':
        'Microsoft Entra ID',
    'Onboarding.chooseOptionStep.runQuickScan.google': 'Google Workspace',
    'Onboarding.chooseOptionStep.deployAgent.title': 'Deploy SaaS Agent',
    'Onboarding.chooseOptionStep.deployAgent.intro':
        'The agent can discover both sanctioned and unsanctioned (Shadow IT) applications and help manage your SaaS landscape by tracking all usage, monitoring security risks, and optimizing licenses.',
    'Onboarding.chooseOptionStep.deployAgent.andMore.number': '+10',
    'Onboarding.chooseOptionStep.deployAgent.andMore.text':
        'Deployment Configurations',
    'Onboarding.chooseOptionStep.graphic.title':
        'What’s included in your free 14-Day trial',
    'Onboarding.chooseOptionStep.graphic.include.1':
        'Full SaaS Inventory Assessment',
    'Onboarding.chooseOptionStep.graphic.include.2':
        'Unlimited Access to Insights & Reporting',
    'Onboarding.chooseOptionStep.graphic.include.3':
        'Discover & Manage Apps for Up to 250 Users',
    'Onboarding.chooseOptionStep.graphic.include.4':
        'Deployment and Integration Setup & Guidance',

    // QuickScan steps
    'Onboarding.quickScanChecklist.title': 'Quick Scan Checklist',
    'Onboarding.quickScanChecklist.setupIntegration':
        'Select an Identity Management Integration',
    'Onboarding.quickScanChecklist.chooseConfigure':
        'Configure Identity Management Integration',
    'Onboarding.quickScanChecklist.groupScanSettings': 'Group Scan Settings',
    'Onboarding.quickScanChecklist.clientProfileReady': 'Client Profile Ready',

    // QuickScan
    'Onboarding.quickScan.footer.switchToDeployAgent':
        'Switch to agent deployment',

    // QuickScan select integration method
    'Onboarding.quickScanSelectStep.title': 'Quick Scan',
    'Onboarding.quickScanSelectStep.subtitle':
        'Set Up Identity Platform Integration',
    'Onboarding.quickScanSelectStep.intro':
        'Choose an option below to uncover which SaaS applications users access via your identity platforms or Single Sign-On.',
    'Onboarding.quickScanSelectStep.microsoftEntraID.title':
        'Microsoft Entra ID',
    'Onboarding.quickScanSelectStep.microsoftEntraID.intro':
        'Import and sync your users, groups, and application data directly from Microsoft Entra ID. Supports multi-tenant environments. You’ll need administrative access to the tenant to complete the required setup.',
    'Onboarding.quickScanSelectStep.google.title': 'Google Workspace',
    'Onboarding.quickScanSelectStep.google.intro':
        'Sync and import users and groups data directly from Google Workspace. You’ll need administrative access to the Google Workspace to complete the required setup.',
    'Onboarding.quickScanSelectStep.okta.intro':
        'Connect Okta to pull security event logs and see which applications are being accessed across your organization. You’ll need administrative access to Okta to complete the setup.\nNote: This integration must be used in conjunction with the ASM agent and/or an identity provider like Microsoft Entra ID or Google Workspace.',

    // QuickScan configureMicrosoftEntraID
    'Onboarding.quickScanConfigure.title': 'Quick Scan',
    'Onboarding.quickScanConfigure.microsoftEntraID.subtitle':
        'Add Client and Set Up the Microsoft Entra ID Integration',
    'Onboarding.quickScanConfigure.google.subtitle':
        'Add Client and Set Up the Google Workspace Integration',

    // Quickscan select groups
    'Onboarding.quickScanSelectGroups.title': 'Quick Scan',
    'Onboarding.quickScanSelectGroups.subtitle':
        'Confirm The Groups To Be Scanned',
    'Onboarding.quickScanSelectGroups.intro':
        '<span style="font-weight:600;">We have succcessfully imported all relevant groups and their respective users from {{integrationType}}.</span> Please confirm if you would like to scan all imported groups or exclude specific ones.',
    'Onboarding.quickScanSelectGroups.scanAllGroups': 'Scan all groups',
    'Onboarding.quickScanSelectGroups.excludeSpecificGroups':
        'Exclude specific groups',
    'Onboarding.quickScanSelectGroups.excludeSpecificGroups.message':
        'Users in excluded groups or organizational units will not be imported or analyzed for SaaS activity.',
    'Onboarding.quickScanSelectGroups.excludeSpecificGroups.selected_one':
        'group selected',
    'Onboarding.quickScanSelectGroups.excludeSpecificGroups.selected_other':
        'groups selected',

    // QuickScan SearchingApps
    'Onboarding.quickScanSearchingAppsStep.title': 'Quick Scan',

    // QuickScan success
    'Onboarding.quickScanSuccess.title': 'The Quick Scan is complete!',
    'Onboarding.quickScanSuccess.subtitle':
        'These are some of the applications what we have uncovered so far!',

    // QuickScan failed
    'Onboarding.quickScanInstallAgentInsteadStep.subtitle':
        'It looks like we haven’t discovered any applications yet.',
    'Onboarding.quickScanInstallAgentInsteadStep.info':
        '<span style="font-weight:600;">No need to worry! Let’s deploy the agent and uncover new applications together!</span> The installation process is quick and only takes five minutes.',
    'Onboarding.quickScanInstallAgentInsteadStep.button': 'Deploy SaaS Agent',

    'Onboarding.whyInstallAgent.title':
        'Boost Your Efficiency: Why Installing the Agent is a Smart Choice',
    'Onboarding.whyInstallAgent.reason.1':
        '<span style="font-weight:600;">Improved Security:</span> Monitor SaaS applications for potential security risks and provide real-time alerts if a threat is detected.',
    'Onboarding.whyInstallAgent.reason.2':
        '<span style="font-weight:600;">Increased Visibility:</span> Provide organizations with greater visibility into their SaaS usage, including which applications are being used, by whom, and how often.',
    'Onboarding.whyInstallAgent.reason.3':
        '<span style="font-weight:600;">Cost Optimization:</span> Help organizations optimize their SaaS spend by identifying redundant or underutilized applications and providing recommendations for cost-saving measures.',

    // DeployAgent steps
    'Onboarding.deployAgent.title': 'Agent Deployment Checklist',
    'Onboarding.deployAgent.setupDeployment':
        'Select a deployment configuration',
    'Onboarding.deployAgent.configureDeployment':
        'Configure deployment with single-script per partner or custom script',
    'Onboarding.deployAgent.completed': 'Agent deployment completed',

    // DeployAgent select integration
    'Onboarding.deployAgentSelectStep.title': 'SaaS Agent Deployment',
    'Onboarding.deployAgentSelectStep.intro1':
        'Auvik SaaS Management deploys its desktop agent by running a PowerShell script (typically run as admin) on the target devices.',
    'Onboarding.deployAgentSelectStep.intro2':
        'The script will configure a tenant under the Auvik SaaS Management Partner hub instance, then grab the Auvik SaaS Management executable from the secure AWS service.',
    'Onboarding.deployAgentSelectStep.intro3':
        'Select the options below to start the agent deployment and we will guide you through the agent deployment process.',
    'Onboarding.deployAgentSelectStep.rmmQuestion':
        'Do you have an RMM or MDM?',
    'Onboarding.deployAgentSelectStep.rmmQuestion.tooltip':
        'RMMs and MDMs let IT pros manage and deploy software to user workstations and servers. Examples include tools like ConnectWise, Addigy, and Microsoft Intune.',

    // DeployAgent configure deployment
    'Onboarding.deployAgentConfigureStep.title': 'SaaS Agent Deployment',
    'Onboarding.deployAgentConfigureStep.subtitle.acronis':
        'Set Up Acronis Configuration Scripts',
    'Onboarding.deployAgentConfigureStep.subtitle.addigy':
        'Set Up Addigy Configuration Scripts',
    'Onboarding.deployAgentConfigureStep.subtitle.cw_automate':
        'Set Up ConnectWise Automate Configuration Scripts',
    'Onboarding.deployAgentConfigureStep.subtitle.atera':
        'Set Up Atera RMM Configuration Scripts',
    'Onboarding.deployAgentConfigureStep.subtitle.at_psa':
        'Set Up Datto | Autotask RMM Configuration Scripts',
    'Onboarding.deployAgentConfigureStep.subtitle.syncro_msp_rmm':
        'Set Up Syncro MSP Configuration Scripts',
    'Onboarding.deployAgentConfigureStep.subtitle.n_able':
        'Set Up N-able RMM Configuration Scripts',
    'Onboarding.deployAgentConfigureStep.subtitle.ninja_one':
        'Set Up NinjaOne Configuration Scripts',
    'Onboarding.deployAgentConfigureStep.subtitle.kaseya_vsa':
        'Set Up Kaseya VSA RMM  Configuration Scripts',
    'Onboarding.deployAgentConfigureStep.subtitle.intune':
        'Set Up Intune Configuration Scripts',
    'Onboarding.deployAgentConfigureStep.subtitle.jamf':
        'Set Up Jamf Configuration Scripts',
    'Onboarding.deployAgentConfigureStep.subtitle.custom_script':
        'Set Up Custom Scripts',
    'Onboarding.deployAgentConfigureStep.continue.info':
        'I confirm that I have have completed all the necessary steps mentioned above to proceed with the deployment of the agent.',
    'Onboarding.deployAgentConfigureStep.continue': 'Continue',
    'Onboarding.deployAgentConfigureStep.goBack':
        'Switch Deployment Configuration',

    // DeployAgent success
    'Onboarding.deployAgentSuccess.title': 'Great news!',
    'Onboarding.deployAgentSuccess.subtitle':
        'Your Auvik SaaS Management experience just got even better!',

    // Success
    'Onboarding.successStep.graphic.title':
        'You’re now ready to fully explore your Auvik SaaS Management Trial.',
    'Onboarding.successStep.box.text':
        'We are excited to show you more of what we have discovered!',
    'Onboarding.successStep.box.button': 'Start Exploring',

    // Quick Scan Results
    'Onboarding.quickScanResults.title':
        "We've scanned your environment and found active applications.",
    'Onboarding.quickScanResults.description':
        'Start by reviewing what is in use across your organization. See which apps were detected, who is using them, and begin identifying areas to investigate or optimize.',

    // Okta Enhancement
    'Onboarding.oktaEnhancement.title': 'Enhance with Okta Integration',
    'Onboarding.oktaEnhancement.subtitle': 'Optional',
    'Onboarding.oktaEnhancement.description':
        'Set up Okta to extend visibility into applications beyond what is covered by your {{integrationType}} integration, helping you build a more complete SaaS inventory.',
    'Onboarding.oktaEnhancement.disclaimer':
        'Prefer to explore first? No problem. You can always set this up later from your dashboard.',
    'Onboarding.oktaEnhancement.button': 'Configure Okta',
    'Onboarding.oktaEnhancement.bonusConfiguration': 'Bonus Configuration'
};
